module.exports = __webpack_public_path__ + "static/media/youtube-logo.f69cfc09.svg";